module.exports = __webpack_public_path__ + "media/Bridge-2.42850c20.mp4";